module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"placeholder":"{0} 入力"}}')
  delete Component.options._Ctor
}
